import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import './TicketDetailSkeleton.scss';
import './TicketDetailSkeleton.scss';

export const TicketDetailSkeleton = () => {
  return (
    <div className='ticket-detail-content'>
      <Card className='ticket-detail-card'>
        <div className='ticket-header-section-skeleton'>
          <div className='ticket-title-section-skeleton'>
            <Skeleton shape='circle' width='20px' height='20px' className='type-icon-skeleton' />
            <Skeleton width='60%' height='32px' className='title-skeleton' />
          </div>
          <Skeleton width='120px' height='36px' className='status-badge-skeleton' borderRadius='12px' />
        </div>

        <Divider />

        <div className='ticket-description-section-skeleton'>
          <Skeleton width='150px' height='24px' className='section-title-skeleton' />
          <Skeleton width='100%' height='20px' className='mb-2' />
          <Skeleton width='100%' height='20px' className='mb-2' />
          <Skeleton width='80%' height='20px' />
        </div>

        <Divider />

        <div className='ticket-attachments-section-skeleton'>
          <Skeleton width='180px' height='24px' className='section-title-skeleton' />
          <div className='attachments-list-skeleton'>
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} width='80px' height='80px' borderRadius='8px' />
            ))}
          </div>
        </div>

        <Divider />

        <div className='ticket-info-section-skeleton'>
          <Skeleton width='200px' height='24px' className='section-title-skeleton' />
          <div className='ticket-info-grid-skeleton'>
            <Skeleton width='100%' height='60px' />
            <Skeleton width='100%' height='60px' />
            <Skeleton width='100%' height='60px' />
          </div>
        </div>

        <Divider />

        <div className='ticket-metadata-section-skeleton'>
          <Skeleton width='100%' height='20px' className='mb-2' />
          <Skeleton width='100%' height='20px' />
        </div>

        <Divider />

        <div className='ticket-comments-section-skeleton'>
          <Skeleton width='150px' height='24px' className='section-title-skeleton' />
          <div className='comments-list-skeleton'>
            {Array.from({ length: 2 }).map((_, index) => (
              <div key={index} className='comment-item-skeleton'>
                <div className='comment-header-skeleton'>
                  <div className='comment-author-skeleton'>
                    <Skeleton shape='circle' width='40px' height='40px' />
                    <Skeleton width='120px' height='20px' />
                  </div>
                  <Skeleton width='100px' height='16px' />
                </div>
                <Skeleton width='100%' height='20px' className='mb-2' />
                <Skeleton width='90%' height='20px' />
              </div>
            ))}
          </div>

          <Divider />

          <div className='add-comment-section-skeleton'>
            <Skeleton width='150px' height='20px' className='mb-2' />
            <Skeleton width='100%' height='100px' borderRadius='6px' />
            <Skeleton width='160px' height='40px' borderRadius='6px' />
          </div>
        </div>
      </Card>
    </div>
  );
};
